import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { HttpService } from '../../http.service';
import { ZoneService } from '../zone.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-zone-table',
  templateUrl: './zone-table.component.html',
  styleUrls: ['./zone-table.component.scss']
})
export class ZoneTableComponent {
  displayedColumns: string[] = ['id', 'name', 'union'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private http: HttpService, public zoneService: ZoneService, private global: GlobalService) {
    this.getZones();
    this.zoneService.downloadZone.subscribe((is_update_zone) => {
      console.log(is_update_zone);
      if (is_update_zone) {
        this.getZones();
      }
    });
    this.global.set_master_page_title = 'Zone';
  }

  showZoneRegister() {
    this.zoneService.is_display_zone_register_component = true;
  }

  hideZoneRegister() {
    this.zoneService.is_display_zone_register_component = false;
  }

  registerZone() {
    this.showZoneRegister();
    console.log('register zone');
    this.zoneService.zoneUpdate.emit(null);
    this.zoneService.set_zone_data = null;
  }

  editZone(zone) {
    this.showZoneRegister();
    console.log(zone);
    this.zoneService.zoneUpdate.emit(zone);
    this.zoneService.set_zone_data = zone;
  }

  getZones() {
    this.http.getZones().subscribe((data: Zone[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Zone>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

}

export interface Zone {
  id: number;
  name: string;
}
